import React from 'react';
import { TABS } from '../../constants';
import EndpointFilter from './EndpointFilter';
import HeaderFilter from './HeaderFilter';
import WaitingPanel from './WaitingPanel';

const SubHeader = ({
  activeTab,
  status,
  endpointStatus,
  handleFilterChange,
  handleEndpointSearch,
  handleEndpointSortByChange,
  endpointSortBy,
  facility,
  facilities,
  specialty,
  specialties,
  type,
  outpatientAppointments,
  connectFromAppointment,
  code,
  rejectAppointment,
}) => {
  const activeAppointments =
    outpatientAppointments &&
    outpatientAppointments.data.filter((appointment) => {
      return appointment.state === 'SessionRequested';
    });
  switch (activeTab) {
    case TABS.Endpoints:
      return (
        <EndpointFilter
          facility={facility === '' ? 0 : facility}
          facilities={facilities}
          endpointSortBy={endpointSortBy}
          endpointStatus={endpointStatus}
          handleFilterChange={handleFilterChange}
          handleEndpointSearch={handleEndpointSearch}
          handleEndpointSortByChange={handleEndpointSortByChange}
        />
      );
    case TABS.AllRequests:
      return (
        <HeaderFilter
          activeTab={activeTab}
          status={status}
          handleFilterChange={handleFilterChange}
          facility={facility}
          facilities={facilities}
          specialty={specialty}
          specialties={specialties}
          type={type}
        />
      );
    case TABS.Appointments:
      return (
        <>
          {/* <AddAppointmentButton
            createOutpatientAppointment={createOutpatientAppointment}
            loadOutpatientAppointments={loadOutpatientAppointments}
          /> */}
          {activeAppointments && activeAppointments.length > 0 && (
            <div>
              <WaitingPanel
                activeAppointments={activeAppointments}
                connectFromAppointment={connectFromAppointment}
                code={code}
                rejectAppointment={rejectAppointment}
              />
            </div>
          )}
        </>
      );
    default:
      return <></>;
  }
};

export default SubHeader;
